'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$139(ps$83) {
  this.a6Q = null;
  this.a6Q = ps$83;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$139 as $c_Lmealorama_jsonCodecs$package$$anon$139 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$139.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$139;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$139() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$139 as $h_Lmealorama_jsonCodecs$package$$anon$139 };
$h_Lmealorama_jsonCodecs$package$$anon$139.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6Q.a.length;
});
$p.g = (function(i) {
  return this.a6Q.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$139 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$139, "mealorama.jsonCodecs$package$$anon$139", ({
  IP: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$139 as $d_Lmealorama_jsonCodecs$package$$anon$139 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$139.js.map
